import userApi from '@/api/user.js'

// 动态路由模块映射
const moduleMap = {
  'user': () => import('@/views/management/UserList.vue'),
  'role': () => import('@/views/management/Role.vue'),
  'pms': () => import('@/views/management/Permission.vue'),
  'dict': () => import('@/views/management/Dict.vue'),
  'scheduleManage': () => import('@/views/management/ScheduleManageV1.vue'),
  'scheduleSearch': () => import('@/views/management/ScheduleSearchV1.vue'),
  'shipAddress': () => import('@/views/management/ShipAddress.vue'),
  'scheduleConst': () => import('@/views/management/ScheduleConst.vue'),
  'groupManage': () => import('@/views/management/GroupManage.vue'),
  'noticeManage': () => import('@/views/management/NoticeManage.vue'),
  'sysLogList': () => import('@/views/management/SysLogList.vue'),
  'towTruckPrice': () => import('@/views/management/TowTruckPrice.vue'),
  'portWiki': () => import('@/views/think_tank/PortWiki.vue'),
  'logisticsWiki': () => import('@/views/think_tank/LogisticsWiki.vue'),
  'webList': () => import('@/views/think_tank/WebList.vue'),
  'companyFile': () => import('@/views/think_tank/CompanyFile.vue'),
  'carrierWiki': () => import('@/views/think_tank/CarrierWiki.vue'),
  'towTruckSearch': () => import('@/views/management/TowTruckSearch.vue'),
  'rateConfig': () => import('@/views/management/RateConfig.vue'),
  'customer': () => import('@/views/management/Customer.vue'),
  'weekReport': () => import('@/views/management/weekReport.vue'),
  'containerSpec': () => import('@/views/management/containerSpec.vue'),
  'dept': () => import('@/views/management/DeptManage.vue'),
  'routeManage': () => import('@/views/management/routeManage.vue'),
  'myOrders': () => import('@/views/order/bookingOrder/myList.vue'),
  'businessOrders': () => import('@/views/order/bookingOrder/businessCenter.vue'),
  'businessOrders2': () => import('@/views/order/bookingOrder/businessCenter2.vue'),
  'Inventory': () => import('@/views/management/wms/Inventory.vue'),
  'Outbound': () => import('@/views/management/wms/Outbound.vue'),
  'queueManage': () => import('@/views/management/wms/queueManage.vue'),
  'StorageFeeConfig': () => import('@/views/management/wms/StorageFeeConfig.vue'),
  'supplierManage': () => import('@/views/management/supplierManage.vue'),
  'phOrderList': () => import('@/views/phOederMgt/phOrderList.vue'),// 菲律宾订单
  'container': () => import('@/views/phOederMgt/container.vue'),//整柜管理
  'wmsInventory': () => import('@/views/phOederMgt/wmsInventory.vue'),// 仓库库存
  'warehouseOutbound': () => import('@/views/phOederMgt/warehouseOutbound.vue'),// 仓库出库
  'bulkCargo': () => import('@/views/phOederMgt/bulkCargo.vue'),// 内部单
  'FlbCustomer': () => import('@/views/phOederMgt/FlbCustomer.vue')// 菲律宾客户
}

let dynamicRoutesAdded = false
let routerInstance = null

export function bindRouter(router) {
  routerInstance = router
}

export function resetDynamicRoutesFlag() {
  dynamicRoutesAdded = false
}

export function isDynamicRoutesAdded() {
  return dynamicRoutesAdded
}

function normalizePath(path) {
  if (!path) return ''
  return path.startsWith('/') ? path : '/' + path
}

function collectExistingRouteKeys() {
  const names = new Set()
  const paths = new Set()
  if (!routerInstance || typeof routerInstance.getRoutes !== 'function') {
    return { names, paths }
  }
  routerInstance.getRoutes().forEach(record => {
    if (record.name) names.add(record.name)
    if (record.path) paths.add(normalizePath(record.path))
  })
  return { names, paths }
}

function isRouteRegistered(route, keys) {
  if (route.name && keys.names.has(route.name)) return true
  if (route.path && keys.paths.has(normalizePath(route.path))) return true
  return false
}

function generateRoutes(menuList) {
  const routes = []
  const seenPaths = new Set()
  if (!Array.isArray(menuList)) return routes

  const walk = (menus) => {
    menus.forEach(menu => {
      const children = menu.children
      const isLeaf = !children || children.length === 0
      if (menu.path && isLeaf && !seenPaths.has(menu.path)) {
        const component = moduleMap[menu.path]
        if (component) {
          seenPaths.add(menu.path)
          routes.push({
            path: '/' + menu.path,
            name: menu.pmsName,
            component,
            meta: {
              title: menu.pmsName,
              fixedLayout: ['myOrders', 'businessOrders', 'businessOrders2', 'phOrderList', 'fclMgmt', 'bulkCargo', 'PhCustomer'].includes(menu.path)
            }
          })
        }
      }
      if (children && children.length > 0) {
        walk(children)
      }
    })
  }

  walk(menuList)
  return routes
}

async function loadMenuList(forceFetch = false) {
  if (!forceFetch) {
    const cached = localStorage.getItem('userMenus')
    if (cached) {
      try {
        return JSON.parse(cached)
      } catch (e) {
        console.error('解析 userMenus 失败', e)
      }
    }
  }
  const res = await userApi.getUserMenu()
  if (res.code !== 200 || !res.data) {
    throw new Error(res.msg || '获取菜单失败')
  }
  localStorage.setItem('userMenus', JSON.stringify(res.data))
  return res.data
}

function mountRoutes(routes) {
  const keys = collectExistingRouteKeys()
  let addedCount = 0
  routes.forEach(route => {
    if (isRouteRegistered(route, keys)) return
    routerInstance.addRoute('Home', route)
    if (route.name) keys.names.add(route.name)
    if (route.path) keys.paths.add(normalizePath(route.path))
    addedCount++
  })
  return addedCount
}

/** 注册动态路由；force=true 时重新读取菜单并补全缺失路由（登录 / 切换账号） */
export async function registerDynamicRoutes(force = false) {
  if (!routerInstance) return false
  if (dynamicRoutesAdded && !force) return true
  const token = localStorage.getItem('token')
  if (!token) return false
  try {
    const menuList = await loadMenuList(force)
    const routes = generateRoutes(menuList)
    if (!routes.length) return false
    mountRoutes(routes)
    dynamicRoutesAdded = true
    return true
  } catch (error) {
    console.error('添加动态路由失败:', error)
    return false
  }
}
